"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.__modelMeta__ = void 0;
var symbol_1 = require("./symbol");
Object.defineProperty(exports, "__modelMeta__", { enumerable: true, get: function () { return symbol_1.__modelMeta__; } });
